var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHelpOnTheWay = function SvgHelpOnTheWay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: "0%",
    y1: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#00B1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#00C8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: "0%",
    x2: "101.131%",
    y1: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#F80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FB0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M58.773 28.484l-2.975.387C54.413 18.226 46.043 9.758 35.423 8.242l.424-2.97c11.954 1.706 21.367 11.23 22.926 23.212zM27.983 5.297l.443 2.967C17.824 9.846 9.508 18.358 8.184 29.009l-2.977-.37C6.697 16.65 16.05 7.077 27.984 5.297zM5.198 35.28l2.979-.361c1.307 10.783 9.776 19.38 20.527 20.856l-.408 2.972C16.194 57.086 6.668 47.418 5.197 35.28zm30.01 23.53l-.353-2.979c10.732-1.27 19.324-9.638 20.89-20.315l2.969.435c-1.764 12.018-11.427 21.429-23.506 22.86zm-6.828-41.113l.734 2.909a11.771 11.771 0 0 0-8.557 8.715l-2.922-.68A14.771 14.771 0 0 1 28.38 17.698zm-10.742 17.67l2.921-.682a11.77 11.77 0 0 0 8.693 8.741l-.7 2.917A14.77 14.77 0 0 1 17.638 35.37zM35.743 46.27l-.76-2.902a11.772 11.772 0 0 0 8.457-8.673l2.92.685a14.772 14.772 0 0 1-10.617 10.89zm10.649-17.513l-2.927.657a11.77 11.77 0 0 0-8.672-8.83l.71-2.915a14.77 14.77 0 0 1 10.889 11.088zM19 32a2 2 0 0 0-2-2H8a2 2 0 1 0 0 4h9a2 2 0 0 0 2-2zm3 0a5 5 0 0 1-5 5H8a5 5 0 0 1 0-10h9a5 5 0 0 1 5 5zm36 0a2 2 0 0 0-2-2h-9a2 2 0 1 0 0 4h9a2 2 0 0 0 2-2zm3 0a5 5 0 0 1-5 5h-9a5 5 0 0 1 0-10h9a5 5 0 0 1 5 5zM32 45a2 2 0 0 0-2 2v9a2 2 0 1 0 4 0v-9a2 2 0 0 0-2-2zm0-3a5 5 0 0 1 5 5v9a5 5 0 0 1-10 0v-9a5 5 0 0 1 5-5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M32 6a2 2 0 0 0-2 2v9a2 2 0 1 0 4 0V8a2 2 0 0 0-2-2zm0-3a5 5 0 0 1 5 5v9a5 5 0 0 1-10 0V8a5 5 0 0 1 5-5z"
  }))));
};
export default SvgHelpOnTheWay;